import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { VersionFeedback } from '@core/models/version-feedback';

@Component({
    selector: 'plugin-share-feedback-core-version-approval-response-list',
    templateUrl: './version-approval-response-list.component.html',
    styleUrls: ['./version-approval-response-list.component.scss']
})
export class PluginShareFeedbackCoreVersionsApprovalResponseListComponent implements OnInit, OnChanges {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    public readonly APPROVAL_PENDING = 0;
    public readonly APPROVAL_APPROVED = 1;
    public readonly APPROVAL_REJECTED = 2;

    @Input() feedbacks: Array<VersionFeedback> = null;
    @Input() prefixUrl: string = '';

    public approvals: Array<VersionFeedback> = [];
    public status: number = this.STATUS_LOADING;
    public archiveFeedbackAccess: boolean = false; // avoid archive feedbacks action in share screens 


    constructor() {}

    ngOnInit() {
        this.loadApprovalsList();
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.feedbacks)
            this.loadApprovalsList();
    }


    protected loadApprovalsList() {
        if(this.feedbacks != null){
            this.approvals = this.feedbacks;
            // console.debug(" the approvals list ",this.approvals);
            this.status = this.STATUS_DONE;
        }
    }


}
